import React from "react";
import { Edit, useForm } from "@refinedev/antd";
import { Form } from "antd";
import { PurchaseTemplateForm } from "./components/PurchaseTemplateForm";
import { REQUEST_TEMPLATE_ONE_QUERY, UPDATE_REQUEST_TEMPLATE_MUTATION } from "./queries";

interface IPurchaseTemplate {
  id: string;
  name: string;
  templateKind?: 'REQUEST' | 'ORDER' | 'RECEIPT' | 'INSPECTION' | 'INVOICE' | 'PLAN' | 'PLAN_REPORT';
  teamId?: string;
  fiscalYear?: number;
  isActive: boolean;
  steps: { order: number; roleSlug: string; stepName?: string }[];
}

export const EditPurchaseTemplate: React.FC = () => {
  const { formProps, saveButtonProps, query   } = useForm<IPurchaseTemplate>({
    resource: "purchaseTemplates",
    action: "edit",
    meta: {
      gqlQuery: REQUEST_TEMPLATE_ONE_QUERY,
      gqlMutation: UPDATE_REQUEST_TEMPLATE_MUTATION,
    },
  });

  const [form] = Form.useForm();

  return (
    <Edit saveButtonProps={saveButtonProps} title="Edit Purchase Template">
      <Form layout="vertical" form={form} {...formProps}>
        <PurchaseTemplateForm  record={query?.data?.data} />
      </Form>
    </Edit>
  );
};